module.exports = __webpack_public_path__ + "img/editBasicDetails2.c21dca4c.jpg";